import React from "react";
import "./Footer.css"; // Make sure to create this CSS file

const Footer = () => {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} NextGenlytics. All Rights Reserved.
    </footer>
  );
};

export default Footer;
